module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/json-loader/index.js!./en.json"));
	}, "Translation-en");
}